import { defineStore } from 'pinia'
export const useUiStore = defineStore('ui', {
  state: () => ({ toast: '', timer: 0 as number | undefined }),
  actions: {
    say(message: string) { this.toast = message; if (this.timer) clearTimeout(this.timer); this.timer = window.setTimeout(() => this.toast = '', 3200) }
  }
})
